import { FC } from 'react';
import { USER_MANAGEMENT_SETTINGS_TABS_TO_CONTENT } from '../consts';
import { SettingsFeatureLock } from '../../../components/LockedFeatures/SettingsFeatureLock';

interface Props {
    selectedTab: string;
}
const UserManagementSettingsContent: FC<Props> = ({ selectedTab }) => {
    const ContentComponent = USER_MANAGEMENT_SETTINGS_TABS_TO_CONTENT[selectedTab];

    if (!ContentComponent) {
        return null;
    }

    return (
        <SettingsFeatureLock id={selectedTab} isTabId={true}>
            <ContentComponent />
        </SettingsFeatureLock>
    );
};

export default UserManagementSettingsContent;
